<ng-template #content1 role="document" let-modal>
  <div class="modal-header p-3">
    <h5 class="modal-title" id="contactsModalLabel">{{ textTitleModal | translate }}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
      (click)="closeModal(); modal.dismiss('Cross click')">
    </button>
  </div>

  <div class="modal-body">
    <input type="hidden" id="id-field" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <div class="row align-items-center">
              <div class="col">
                <ul ngbNav #contactsNav="ngbNav" [(activeId)]="nabTabActive" (activeIdChange)="activeIdChangeNabTab()"
                  class="nav nav-tabs-custom rounded card-header-tabs border-bottom-0">
                  <!-- LISTAGEM -->
                  <li [ngbNavItem]="1">
                    <a ngbNavLink>{{ textTitleTabList | translate }}</a>

                    <ng-template ngbNavContent>
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="card" id="costumers-contatctsList">
                            <div class="card-header border-0">
                              <div class="row g-4 align-items-center">
                                <div class="col-xxl-4">
                                  <div class="search-box" [class.placeholder-glow]="hideElement">
                                    <input type="text" name="searchTerm" class="form-control" [attr.placeholder]="
                                      !hideElement ? ( 't-search-for' | translate) + ' ' + ('t-name' | translate | lowercase) +
                                      ', ' + ('t-email' | translate | lowercase) + ' ...' : ''"
                                      [formControl]="queryField" [class.placeholder]="hideElement"
                                      [attr.disabled]="hideElement ? true : null" />
                                    <i class="ri-search-line search-icon" *ngIf="!hideElement"></i>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="card-body">
                              <div>
                                <div class="table-responsive table-card" *ngIf="contacts && total > 0">
                                  <table class="table">
                                    <thead>
                                      <tr class="bg-light text-muted">
                                        <th scope="col" style="width: 50px;">
                                          <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="checkAll"
                                              [(ngModel)]="masterSelected" (change)="checkUncheckAll($event)" />
                                          </div>
                                        </th>

                                        <th>{{ 't-name' | translate }}</th>
                                        <th>{{ 't-email' | translate }}</th>
                                        <th>{{ 't-phone' | translate }}</th>
                                        <th *ngIf="isShowCostumersForm">
                                          {{ 't-new-contacts.t-compatibility' | translate }}
                                        </th>
                                        <th>{{ 't-status' | translate }}</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      <ng-container *ngFor="let contact of contacts">
                                        <tr *ngIf="!contact.isAddToProperty">
                                          <th scope="row">
                                            <div class="form-check">
                                              <input class="form-check-input" type="checkbox"
                                                [(ngModel)]="contact.isSelected"
                                                (change)="checkUncheck($event, contact)" />
                                            </div>
                                          </th>

                                          <td>
                                            <div class="d-flex align-items-left">
                                              <div class="flex-shrink-0 me-2">
                                                <img [src]="'assets/images/users/user-dummy-img.jpg'" alt=""
                                                  class="avatar-xxs rounded-circle image_src object-cover" />
                                              </div>

                                              <div class="flex-grow-1 ms-2 name">
                                                {{ contact.firstName }} {{ contact.lastName }}
                                              </div>
                                            </div>
                                          </td>

                                          <td>{{ contact.email }}</td>
                                          <td>{{ contact.phone }}</td>

                                          <td *ngIf="isShowCostumersForm" class="text-center">
                                            <div *ngIf="contact.propertyQuality" class="circular-progress">
                                              <svg width="40" height="40" viewBox="0 0 36 36">
                                                <circle class="circle-bg" cx="18" cy="18" r="15.91549430918954"
                                                  fill="none" stroke="#e6e6e6" stroke-width="3"></circle>
                                                <circle class="circle-progress" cx="18" cy="18" r="15.91549430918954"
                                                  fill="none" [attr.stroke-dasharray]="getDash(contact.propertyQuality)"
                                                  [attr.stroke]="
                                                    contact.propertyQuality < 33
                                                      ? '#dc3545'
                                                      : contact.propertyQuality != 100
                                                      ? 'rgb(247, 184, 75)'
                                                      : '#4caf50'
                                                  " stroke-width="3" stroke-linecap="round"></circle>
                                              </svg>
                                              <div [style.color]="
                                                  contact.propertyQuality < 33
                                                    ? '#dc3545'
                                                    : contact.propertyQuality != 100
                                                    ? 'rgb(247, 184, 75)'
                                                    : '#4caf50'
                                                " class="progress-text">
                                                {{ contact.propertyQuality }}%
                                              </div>
                                            </div>
                                          </td>

                                          <td>
                                            <div *ngIf="contact.status" class="d-flex align-items-center">
                                              <i class="ri-checkbox-circle-line text-success me-1"></i>
                                              {{ 't-active' | translate }}
                                            </div>

                                            <div *ngIf="!contact.status" class="d-flex align-items-center">
                                              <i class="ri-close-circle-line text-danger me-1"></i>
                                              {{ 't-inactive' | translate }}
                                            </div>
                                          </td>
                                        </tr>
                                      </ng-container>
                                    </tbody>
                                  </table>
                                </div>

                                <!-- PAGINATION -->
                                <div class="row justify-content-md-between align-items-md-center mt-3"
                                  *ngIf="total > 0">
                                  <div class="col col-sm-6">
                                    <div class="dataTables_info mb-2">
                                      {{ 't-showing' | translate }} {{ startIndex }}
                                      {{ 't-table-to' | translate }} {{ endIndex }}
                                      {{ 't-table-of' | translate }} {{ total }}
                                      {{ 't-table-entries' | translate }}
                                    </div>
                                  </div>
                                  <div class="col col-sm-6">
                                    <div class="float-sm-end listjs-pagination">
                                      <ngb-pagination [maxSize]="6" [collectionSize]="total" [(page)]="page"
                                        [pageSize]="pageSize" (pageChange)="refreshContacts()">
                                      </ngb-pagination>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="py-4 text-center" *ngIf="noresult">
                              <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                                colors="primary:#405189,secondary:#0ab39c" style="width:72px;height:72px">
                              </lord-icon>
                              <div class="mt-4">
                                <h5>{{ 't-no-result-message' | translate }}</h5>
                              </div>
                            </div>

                            <app-spinner></app-spinner>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </li>

                  <!-- CREATE -->
                  <li [ngbNavItem]="2">
                    <a ngbNavLink>{{ textTitleNewContact | translate }}</a>

                    <ng-template ngbNavContent>
                      <!-- FORM CUSTOMER -->
                      <form (ngSubmit)="saveCostumers()" [formGroup]="costumersDetailsForm" *ngIf="isShowCostumersForm">
                        <!-- Abas interno: Básico / Avançado -->
                        <ul ngbNav #advancedNavC="ngbNav" [activeId]="1"
                          class="border-bottom-0 justify-content-end mb-2 mx-n1 nav nav-tabs-custom" role="tablist">
                          <!-- ABA BÁSICO -->
                          <li [ngbNavItem]="1">
                            <a ngbNavLink class="nav-link" data-bs-toggle="tab" role="tab">
                              {{ 't-basic' | translate }}
                            </a>

                            <ng-template ngbNavContent>
                              <div class="row">
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="firstNameInput" class="form-label">
                                      {{'t-first-name' | translate}} *
                                    </label>
                                    <input type="text" class="form-control" id="firstNameInput"
                                      placeholder="{{ 't-enter' | translate }} {{'t-first-name' | translate | lowercase}}"
                                      required formControlName="firstName"
                                      [ngClass]="{ 'is-invalid': submittedCostumersForm && costumersForm['firstName'].errors }" />
                                    <div *ngIf="submittedCostumersForm && costumersForm['firstName'].errors"
                                      class="invalid-feedback" align="left">
                                      <div *ngIf="costumersForm['firstName'].errors['required']">
                                        {{'t-first-name' | translate}}
                                        {{ 't-general.t-is-required'|translate }}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="lastNameInput" class="form-label">
                                      {{'t-last-name' | translate}} *
                                    </label>
                                    <input type="text" class="form-control" id="lastNameInput"
                                      placeholder="{{ 't-enter' | translate }} {{'t-last-name' | translate | lowercase}}"
                                      required formControlName="lastName"
                                      [ngClass]="{ 'is-invalid': submittedCostumersForm && costumersForm['lastName'].errors }" />
                                    <div *ngIf="submittedCostumersForm && costumersForm['lastName'].errors"
                                      class="invalid-feedback" align="left">
                                      <div *ngIf="costumersForm['lastName'].errors['required']">
                                        {{'t-last-name' | translate}}
                                        {{ 't-general.t-is-required'|translate }}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-lg-4">
                                  <div>
                                    <div
                                      class="form-check form-check-inline form-switch form-switch-md form-switch-success mt-4">
                                      <input class="form-check-input" type="checkbox" role="switch"
                                        formControlName="status" (change)="switchStatus($event)" id="SwitchStatusc">
                                      <label class="form-check-label" for="SwitchStatusc">
                                        {{this.costumersDetailsForm.get('status')?.value?
                                        ('t-active'| translate):
                                        ('t-inactive'| translate)}}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="emailInput" class="form-label">{{'t-email' | translate}}</label>
                                    <input type="email" class="form-control" id="emailInput"
                                      (input)="contactInputChange($event)"
                                      placeholder="{{ 't-enter' | translate }} {{'t-email' | translate | lowercase}}"
                                      formControlName="email" name="email"
                                      [ngClass]="{ 'is-invalid': submittedCostumersForm && costumersForm['email'].errors }" />
                                    <span *ngIf="emailExists" class="text-danger text-error">
                                      {{'t-contact-exists' | translate}}</span>
                                    <span *ngIf="emailInvalid" class="text-danger text-error">
                                      {{'t-email-invalid' | translate}}</span>
                                    <div *ngIf="submittedCostumersForm && costumersForm['email'].errors"
                                      class="invalid-feedback" align="left">
                                      <div *ngIf="costumersForm['email'].errors['required']">
                                        {{'t-email' | translate}}
                                        {{ 't-general.t-is-required'|translate }}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="phoneNumberInput" class="form-label">{{'t-phone' | translate}}</label>
                                    <input type="text" class="form-control" (input)="contactInputChange($event)"
                                      id="phoneNumberInput"
                                      placeholder="{{'t-enter' | translate}} {{'t-phone' | translate | lowercase}}"
                                      formControlName="phoneNumber" name="phoneNumber" />
                                    <span *ngIf="phoneExists" class="text-danger text-error"> {{'t-contact-exists' |
                                      translate}}</span>
                                    <span *ngIf="phoneInvalid" class="text-danger text-error"> {{'t-phone-invalid' |
                                      translate}}</span>
                                  </div>
                                </div>

                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="contactTypeInput" class="form-label">{{'t-contact-source' |
                                      translate}} *</label>
                                    <ng-select [items]="contactTypes" [multiple]="false"
                                      bindValue="id" placeholder="{{'t-contact-source-placeholder' | translate}}"
                                      required formControlName="contactType"
                                      [ngClass]="{ 'is-invalid': submittedCostumersForm && ownersForm['contactType'].errors }">
                                      <ng-template ng-label-tmp let-item="item">
                                        {{ item.translateKey ? (item.translateKey | translate) : (item.name || item.description) }}
                                      </ng-template>
                                      <ng-template ng-option-tmp let-item="item">
                                        {{ item.translateKey ? (item.translateKey | translate) : (item.name || item.description) }}
                                      </ng-template>
                                    </ng-select>
                                    <div *ngIf="submittedCostumersForm && ownersForm['contactType'].errors"
                                      class="invalid-feedback" align="left">
                                      <div *ngIf="ownersForm['contactType'].errors['required']">
                                        {{'t-contact-source-error-required' | translate}}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-12">
                                  <div class="mb-3">
                                    <label for="obsInput" class="form-label">
                                      {{'t-observations' | translate}}
                                    </label>
                                    <textarea type="" class="form-control" id="obsInput"
                                      placeholder="{{'t-enter' | translate}} {{'t-observations' | translate | lowercase}}"
                                      formControlName="obs" rows="5"></textarea>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-12">
                                  <h6>{{'t-attached-file' | translate}}</h6>
                                  <div class="form-check form-check-success mb-3"
                                    *ngIf="costumersDetailsForm.get('hasFile')?.value">
                                    <input class="form-check-input" type="checkbox" id="formCheck8"
                                      formControlName="dataConsent">
                                    <label class="form-check-label" for="formCheck8"
                                      [ngClass]="{'text-muted':!costumersDetailsForm.get('dataConsent')?.value}">
                                      {{'t-attached-file-message' | translate}}
                                    </label>
                                  </div>
                                </div>

                                <input hidden class="form-control" type="file" id="input-filec"
                                  (change)="onFileChange($event)">
                                <div class="col-lg-12">
                                  <input type="hidden" formControlName="hasFile">
                                  <div class="d-flex align-items-center border border-dashed p-2 rounded"
                                    *ngIf="!costumersDetailsForm.get('hasFile')?.value">
                                    <a href="javascript:void(0);"
                                      class="btn btn-outline-primary btn-label waves-effect waves-light btn-sm"
                                      (click)="addFileCostumer()">
                                      <div class="d-flex">
                                        <div class="flex-shrink-0">
                                          <i class="ri-file-upload-line label-icon align-middle fs-16 me-2"></i>
                                        </div>
                                        <div class="flex-grow-1">
                                          {{'t-upload-file' | translate}}
                                        </div>
                                      </div>
                                    </a>
                                  </div>

                                  <div class="d-flex align-items-center border border-dashed p-2 rounded"
                                    *ngIf="costumersDetailsForm.get('hasFile')?.value">
                                    <div class="flex-shrink-0 avatar-sm">
                                      <div class="avatar-title bg-light rounded">
                                        <i class="ri-file-zip-line fs-20 text-primary"></i>
                                      </div>
                                    </div>
                                    <div class="flex-grow-1 ms-3">
                                      <h6 class="mb-1">
                                        <a
                                          href="javascript:void(0);">{{costumersDetailsForm.get('file')?.value.name}}</a>
                                      </h6>
                                      <small
                                        class="text-muted">{{formatSizeUnits(costumersDetailsForm.get('file')?.value.size)}}</small>
                                    </div>
                                    <div class="hstack gap-3 fs-16">
                                      <a href="{{dirContactsfiles}}costumer/{{contactUpdate.id}}/{{costumersDetailsForm.get('file')?.value.path}}"
                                        target="_blank" class="text-muted" *ngIf="contactUpdate">
                                        <i class="ri-download-2-line"></i></a>
                                      <a href="javascript:void(0);" class="text-muted" (click)="deleteFile()">
                                        <i class="ri-delete-bin-line"></i></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </li>

                          <!-- ABA AVANÇADO -->
                          <li [ngbNavItem]="2">
                            <a ngbNavLink class="nav-link" data-bs-toggle="tab" role="tab">
                              {{ 't-advanced' | translate }}
                            </a>

                            <ng-template ngbNavContent>
                              <div class="row my-3">
                                <div class="col-xxl-4">
                                  <label for="fiscalIdentification" class="form-label">
                                    {{'t-contacts-advanced.t-fiscal-identification' | translate}}
                                  </label>
                                  <input type="text"
                                    placeholder="{{'t-contacts-advanced.t-fiscal-identification' | translate}}"
                                    class="form-control" id="fiscalIdentification"
                                    formControlName="fiscalIdentification">
                                </div>

                                <div class="col-xxl-4">
                                  <label for="maritalStatus" class="form-label">
                                    {{'t-contacts-advanced.t-marital-status' | translate}}
                                  </label>
                                  <ng-select placeholder="{{'t-contacts-advanced.t-marital-status' | translate}}"
                                    formControlName="maritalStatus">
                                    <ng-option *ngFor="let option of maritalStatus" [value]="option.value">
                                      {{option.text | translate}}
                                    </ng-option>
                                  </ng-select>
                                </div>

                                <div class="col-xxl-4">
                                  <label for="propertyRegime" class="form-label">
                                    {{'t-contacts-advanced.t-marital-regime' | translate}}
                                  </label>
                                  <ng-select placeholder="{{'t-contacts-advanced.t-marital-regime' | translate}}"
                                    formControlName="propertyRegime">
                                    <ng-option *ngFor="let option of maritalPropertyRegime" [value]="option.value">
                                      {{option.text | translate}}
                                    </ng-option>
                                  </ng-select>
                                </div>
                              </div>

                              <div class="row my-3">
                                <div class="col-xxl-3">
                                  <label for="birthDate" class="form-label">{{'t-contacts-advanced.t-birth-date' |
                                    translate}}</label>
                                  <input class="form-control flatpickr-input" [convertModelValue]="true"
                                    [dateFormat]="'d/m/Y'" mwlFlatpickr [allowInput]="true" appDateDigitsMask
                                    placeholder="{{'t-contacts-advanced.t-birth-date' | translate}}" id="birthDate"
                                    formControlName="birthDate">
                                </div>

                                <div class="col-xxl-3">
                                  <label for="docType" class="form-label">{{'t-contacts-advanced.t-doc-type' |
                                    translate}}</label>
                                  <ng-select placeholder="{{'t-contacts-advanced.t-doc-type' | translate}}"
                                    formControlName="docType">
                                    <ng-option *ngFor="let option of documentTypes" [value]="option.value">
                                      {{option.text | translate}}
                                    </ng-option>
                                  </ng-select>
                                </div>

                                <div class="col-xxl-3">
                                  <label for="docNumber" class="form-label">{{'t-contacts-advanced.t-doc-number' |
                                    translate}}</label>
                                  <input type="text" placeholder="{{'t-contacts-advanced.t-doc-number' | translate}}"
                                    class="form-control" id="docNumber" formControlName="docNumber">
                                </div>

                                <div class="col-xxl-3">
                                  <label for="docExpiration" class="form-label">{{'t-contacts-advanced.t-doc-expiration'
                                    | translate}}</label>
                                  <input class="form-control flatpickr-input" [convertModelValue]="true"
                                    [dateFormat]="'d/m/Y'" mwlFlatpickr [allowInput]="true" appDateDigitsMask
                                    placeholder="{{'t-contacts-advanced.t-doc-expiration' | translate}}"
                                    id="docExpiration" formControlName="docExpiration">
                                </div>
                              </div>

                              <div class="row my-3">
                                <div class="col-xxl-3">
                                  <label for="naturalness" class="form-label">{{'t-contacts-advanced.t-naturalness' |
                                    translate}}</label>
                                  <input type="text" placeholder="{{'t-contacts-advanced.t-naturalness' | translate}}"
                                    class="form-control" id="naturalness" formControlName="naturalness">
                                </div>

                                <div class="col-xxl-3">
                                  <label for="nationality" class="form-label">{{'t-contacts-advanced.t-nationality' |
                                    translate}}</label>
                                  <input type="text" placeholder="{{'t-contacts-advanced.t-nationality' | translate}}"
                                    class="form-control" id="nationality" formControlName="nationality">
                                </div>

                                <div class="col-xxl-3">
                                  <label for="city" class="form-label">{{'t-contacts-advanced.t-city' |
                                    translate}}</label>
                                  <input type="text" placeholder="{{'t-contacts-advanced.t-city' | translate}}"
                                    class="form-control" id="city" formControlName="city">
                                </div>

                                <div class="col-xxl-3">
                                  <label for="zipCode" class="form-label">{{'t-contacts-advanced.t-postal-code' |
                                    translate}}</label>
                                  <input type="text" placeholder="{{'t-contacts-advanced.t-postal-code' | translate}}"
                                    class="form-control" id="zipCode" formControlName="zipCode">
                                </div>
                              </div>

                              <div class="row my-3">
                                <div class="col-xxl-4">
                                  <label for="fiscalCountry" class="form-label">{{'t-contacts-advanced.t-fiscal-country'
                                    | translate}}</label>
                                  <input type="text"
                                    placeholder="{{'t-contacts-advanced.t-fiscal-country' | translate}}"
                                    class="form-control" id="fiscalCountry" formControlName="fiscalCountry">
                                </div>
                                <div class="col-xxl-8">
                                  <label for="fiscalAddress" class="form-label">{{'t-contacts-advanced.t-fiscal-address'
                                    | translate}}</label>
                                  <input type="text"
                                    placeholder="{{'t-contacts-advanced.t-fiscal-address' | translate}}"
                                    class="form-control" id="fiscalAddress" formControlName="fiscalAddress">
                                </div>
                              </div>

                              <div class="row my-3">
                                <div class="col-xxl-4">
                                  <label for="fiscalPostalCode"
                                    class="form-label">{{'t-contacts-advanced.t-fiscal-postal-code' |
                                    translate}}</label>
                                  <input type="text"
                                    placeholder="{{'t-contacts-advanced.t-fiscal-postal-code' | translate}}"
                                    class="form-control" id="fiscalPostalCode" formControlName="fiscalPostalCode">
                                </div>
                                <div class="col-xxl-4">
                                  <label for="fiscalCity" class="form-label">{{'t-contacts-advanced.t-fiscal-city' |
                                    translate}}</label>
                                  <input type="text" placeholder="{{'t-contacts-advanced.t-fiscal-city' | translate}}"
                                    class="form-control" id="fiscalCity" formControlName="fiscalCity">
                                </div>
                                <div class="col-xxl-4">
                                  <label for="occupation" class="form-label">{{'t-contacts-advanced.t-occupation' |
                                    translate}}</label>
                                  <input type="text" placeholder="{{'t-contacts-advanced.t-occupation' | translate}}"
                                    class="form-control" id="occupation" formControlName="occupation">
                                </div>
                              </div>

                              <div class="row my-3">
                                <div class="col-xxl-4">
                                  <label for="employer" class="form-label">{{'t-contacts-advanced.t-employer' |
                                    translate}}</label>
                                  <input type="text" placeholder="{{'t-contacts-advanced.t-employer' | translate}}"
                                    class="form-control" id="employer" formControlName="employer">
                                </div>
                                <div class="col-xxl-4">
                                  <label for="actionType" class="form-label">{{'t-contacts-advanced.t-action-type' |
                                    translate}}</label>
                                  <ng-select placeholder="{{'t-contacts-advanced.t-action-type' | translate}}"
                                    formControlName="actionType">
                                    <ng-option *ngFor="let option of proposerActionTypes" [value]="option.value">
                                      {{option.text | translate}}
                                    </ng-option>
                                  </ng-select>
                                </div>
                                <div *ngIf="costumersForm['actionType'].value == 'OTHER'" class="col-xxl-4">
                                  <label for="actionTypeOther"
                                    class="form-label">{{'t-contacts-advanced.t-action-type-other' | translate}}</label>
                                  <input type="text"
                                    placeholder="{{'t-contacts-advanced.t-action-type-other' | translate}}"
                                    class="form-control" id="actionTypeOther" formControlName="actionTypeOther">
                                </div>
                              </div>

                              <div class="row my-3 align-items-center">
                                <div class="col-xxl-4">
                                  <div class="form-check form-switch form-switch-md form-check-success">
                                    <input class="form-check-input" type="checkbox" role="switch"
                                      id="SwitchPoliticalPositions" formControlName="politicalPositions">
                                    <label class="form-check-label" for="SwitchPoliticalPositions">
                                      {{'t-contacts-advanced.t-political-positions' | translate}}
                                    </label>
                                  </div>
                                </div>
                                <div *ngIf="costumersForm['politicalPositions'].value" class="col-xxl-8">
                                  <label for="politicalDesc" class="form-label">{{'t-contacts-advanced.t-political-desc'
                                    | translate}}</label>
                                  <input placeholder="{{'t-contacts-advanced.t-political-desc' | translate}}"
                                    class="form-control" id="politicalDesc" formControlName="politicalDesc">
                                </div>
                              </div>
                            </ng-template>
                          </li>
                        </ul>

                        <div [ngbNavOutlet]="advancedNavC"></div>
                      </form>

                      <!-- FORM OWNER -->
                      <form (ngSubmit)="saveOwners()" [formGroup]="ownersDetailsForm" *ngIf="isShowOwnersForm">
                        <ul ngbNav #advancedNavO="ngbNav" [activeId]="1"
                          class="border-bottom-0 justify-content-end mb-3 mx-n1 nav nav-tabs-custom" role="tablist">
                          <!-- ABA BÁSICO -->
                          <li [ngbNavItem]="1">
                            <a ngbNavLink class="nav-link">{{ 't-basic' | translate }}</a>

                            <ng-template ngbNavContent>
                              <div class="row">
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="firstNameInput" class="form-label">
                                      {{'t-first-name' | translate}} *
                                    </label>

                                    <input type="text" class="form-control" id="firstNameInput"
                                      placeholder="{{'t-enter' | translate}} {{'t-first-name' | translate | lowercase}}"
                                      required formControlName="firstName"
                                      [ngClass]="{ 'is-invalid': submittedOwnersForm && ownersForm['firstName'].errors }" />
                                    <div *ngIf="submittedOwnersForm && ownersForm['firstName'].errors"
                                      class="invalid-feedback" align="left">
                                      <div *ngIf="ownersForm['firstName'].errors['required']">
                                        {{'t-first-name' | translate}} {{ 't-general.t-is-required'|translate }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="lastNameInput" class="form-label">{{'t-last-name' | translate}}
                                      *</label>
                                    <input type="text" class="form-control" id="lastNameInput"
                                      placeholder="{{'t-enter' | translate}} {{'t-last-name' | translate | lowercase}}"
                                      required formControlName="lastName"
                                      [ngClass]="{ 'is-invalid': submittedOwnersForm && ownersForm['lastName'].errors }" />
                                    <div *ngIf="submittedOwnersForm && ownersForm['lastName'].errors"
                                      class="invalid-feedback" align="left">
                                      <div *ngIf="ownersForm['lastName'].errors['required']">
                                        {{'t-last-name' | translate}} {{ 't-general.t-is-required'|translate }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="contactTypeInput" class="form-label">{{'t-contact-source' |
                                      translate}} *</label>
                                    <ng-select [items]="contactTypes" [multiple]="false"
                                      bindValue="id" placeholder="{{'t-contact-source-placeholder' | translate}}"
                                      required formControlName="contactType"
                                      [ngClass]="{ 'is-invalid': submittedCostumersForm && costumersForm['contactType'].errors }">
                                      <ng-template ng-label-tmp let-item="item">
                                        {{ item.translateKey ? (item.translateKey | translate) : (item.name || item.description) }}
                                      </ng-template>
                                      <ng-template ng-option-tmp let-item="item">
                                        {{ item.translateKey ? (item.translateKey | translate) : (item.name || item.description) }}
                                      </ng-template>
                                    </ng-select>
                                    <div *ngIf="submittedCostumersForm && costumersForm['contactType'].errors"
                                      class="invalid-feedback" align="left">
                                      <div *ngIf="costumersForm['contactType'].errors['required']">
                                        {{'t-contact-source-error-required' | translate}}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="emailInput" class="form-label">{{'t-email' | translate}}</label>
                                    <input type="email" class="form-control" id="emailInput"
                                      placeholder="{{'t-enter' | translate}} {{'t-email' | translate | lowercase}}"
                                      formControlName="email"
                                      [ngClass]="{ 'is-invalid': submittedOwnersForm && ownersForm['email'].errors }" />
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="phoneNumber1Input" class="form-label">{{'t-phone' | translate}}</label>
                                    <input type="text" class="form-control" id="phoneNumber1Input"
                                      placeholder="{{'t-enter' | translate}} {{'t-phone' | translate | lowercase}}"
                                      formControlName="phoneNumber1" />
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="phoneNumber2Input" class="form-label">{{'t-phone' | translate}}
                                      2</label>
                                    <input type="text" class="form-control" id="phoneNumber2Input"
                                      placeholder="{{'t-enter' | translate}} {{'t-phone' | translate | lowercase}} 2"
                                      formControlName="phoneNumber2" />
                                  </div>
                                </div>
                              </div>

                              <!-- <div class="row">
                                <div class="col-lg-8">
                                  <div class="mb-3">
                                    <label for="addressInput" class="form-label">{{'t-address' | translate}}</label>
                                    <input type="text" class="form-control" id="addressInput"
                                      placeholder="{{'t-enter' | translate}} {{'t-address' | translate | lowercase}}"
                                      formControlName="address" />
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="zipCodeInput" class="form-label">{{'t-zip-code' | translate}}</label>
                                    <input type="text" class="form-control" id="zipCodeInput"
                                      placeholder="{{'t-enter' | translate}} {{'t-zip-code' | translate}}"
                                      formControlName="zipCode" />
                                  </div>
                                </div>
                              </div> -->
                              <div class="row">
                                <div class="col-lg-12">
                                  <div class="mb-3">
                                    <label for="obsInput" class="form-label">
                                      {{'t-observations' | translate}}
                                    </label>
                                    <textarea type="" class="form-control" id="obsInput"
                                      placeholder="{{'t-enter' | translate}} {{'t-observations' | translate | lowercase}}"
                                      formControlName="obs" rows="5"></textarea>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-12">
                                  <div class="form-check form-switch form-switch-md form-switch-success mt-3">
                                    <input class="form-check-input" type="checkbox" role="switch" id="SwitchStatus"
                                      formControlName="status" (change)="switchStatus($event)">

                                    <label class="form-check-label" for="SwitchStatus">
                                      {{statusOwners? ('t-active' | translate): ('t-inactive' | translate)}}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </li>

                          <!-- ABA AVANÇADO -->
                          <li [ngbNavItem]="2">
                            <a ngbNavLink class="nav-link">{{ 't-advanced' | translate }}</a>

                            <ng-template ngbNavContent>
                              <div class="row my-3">
                                <div class="col-xxl-4">
                                  <label for="fiscalIdentification" class="form-label">
                                    {{'t-contacts-advanced.t-fiscal-identification' | translate}}
                                  </label>

                                  <input type="text"
                                    placeholder="{{'t-contacts-advanced.t-fiscal-identification' | translate}}"
                                    class="form-control" id="fiscalIdentification"
                                    formControlName="fiscalIdentification">
                                </div>

                                <div class="col-xxl-4">
                                  <label for="maritalStatus" class="form-label">
                                    {{'t-contacts-advanced.t-marital-status' | translate}}
                                  </label>

                                  <ng-select placeholder="{{'t-contacts-advanced.t-marital-status' | translate}}"
                                    formControlName="maritalStatus">
                                    <ng-option *ngFor="let option of maritalStatus" [value]="option.value">
                                      {{option.text | translate}}
                                    </ng-option>
                                  </ng-select>
                                </div>

                                <div class="col-xxl-4">
                                  <label for="propertyRegime" class="form-label">
                                    {{'t-contacts-advanced.t-marital-regime' | translate}}
                                  </label>

                                  <ng-select placeholder="{{'t-contacts-advanced.t-marital-regime' | translate}}"
                                    formControlName="propertyRegime">
                                    <ng-option *ngFor="let option of maritalPropertyRegime" [value]="option.value">
                                      {{option.text | translate}}
                                    </ng-option>
                                  </ng-select>
                                </div>
                              </div>

                              <div class="row my-3">
                                <div class="col-xxl-3">
                                  <label for="birthDate" class="form-label">{{'t-contacts-advanced.t-birth-date' |
                                    translate}}</label>

                                  <input class="form-control flatpickr-input" [convertModelValue]="true"
                                    [dateFormat]="'d/m/Y'" mwlFlatpickr [allowInput]="true" appDateDigitsMask
                                    placeholder="{{'t-contacts-advanced.t-birth-date' | translate}}"
                                    class="form-control" id="birthDate" formControlName="birthDate">
                                </div>

                                <div class="col-xxl-3">
                                  <label for="docType" class="form-label">{{'t-contacts-advanced.t-doc-type' |
                                    translate}}</label>

                                  <ng-select placeholder="{{'t-contacts-advanced.t-doc-type' | translate}}"
                                    formControlName="docType">
                                    <ng-option *ngFor="let option of documentTypes" [value]="option.value">
                                      {{option.text | translate}}
                                    </ng-option>
                                  </ng-select>
                                </div>

                                <div class="col-xxl-3">
                                  <label for="docNumber" class="form-label">{{'t-contacts-advanced.t-doc-number' |
                                    translate}}</label>

                                  <input type="text" placeholder="{{'t-contacts-advanced.t-doc-number' | translate}}"
                                    class="form-control" id="docNumber" formControlName="docNumber">
                                </div>

                                <div class="col-xxl-3">
                                  <label for="docExpiration" class="form-label">{{'t-contacts-advanced.t-doc-expiration'
                                    |
                                    translate}}</label>

                                  <input class="form-control flatpickr-input" [convertModelValue]="true"
                                    [dateFormat]="'d/m/Y'" mwlFlatpickr [allowInput]="true" appDateDigitsMask
                                    placeholder="{{'t-contacts-advanced.t-doc-expiration' | translate}}"
                                    class="form-control" id="docExpiration" formControlName="docExpiration">
                                </div>
                              </div>

                              <div class="row my-3">
                                <div class="col-xxl-3">
                                  <label for="naturalness" class="form-label">{{'t-contacts-advanced.t-naturalness' |
                                    translate}}</label>

                                  <input type="text" placeholder="{{'t-contacts-advanced.t-naturalness' | translate}}"
                                    class="form-control" id="naturalness" formControlName="naturalness">
                                </div>

                                <div class="col-xxl-3">
                                  <label for="nationality" class="form-label">{{'t-contacts-advanced.t-nationality' |
                                    translate}}</label>

                                  <input type="text" placeholder="{{'t-contacts-advanced.t-nationality' | translate}}"
                                    class="form-control" id="nationality" formControlName="nationality">
                                </div>

                                <div class="col-xxl-3">
                                  <label for="city" class="form-label">{{'t-contacts-advanced.t-city' |
                                    translate}}</label>

                                  <input type="text" placeholder="{{'t-contacts-advanced.t-city' | translate}}"
                                    class="form-control" id="city" formControlName="city">
                                </div>

                                <div class="col-xxl-3">
                                  <label for="zipCode>" class="form-label">{{'t-contacts-advanced.t-postal-code' |
                                    translate}}</label>

                                  <input type="text" placeholder="{{'t-contacts-advanced.t-postal-code' | translate}}"
                                    class="form-control" id="zipCode" formControlName="zipCode">
                                </div>
                              </div>

                              <div class="row my-3">
                                <div class="col-xxl-4">
                                  <label for="fiscalCountry" class="form-label">{{'t-contacts-advanced.t-fiscal-country'
                                    |
                                    translate}}</label>

                                  <input type="text"
                                    placeholder="{{'t-contacts-advanced.t-fiscal-country' | translate}}"
                                    class="form-control" id="fiscalCountry" formControlName="fiscalCountry">
                                </div>
                                <div class="col-xxl-8">
                                  <label for="fiscalAddress" class="form-label">{{'t-contacts-advanced.t-fiscal-address'
                                    |
                                    translate}}</label>
                                  <input type="text"
                                    placeholder="{{'t-contacts-advanced.t-fiscal-address' | translate}}"
                                    class="form-control" id="fiscalAddress" formControlName="fiscalAddress">
                                </div>
                              </div>

                              <div class="row my-3">
                                <div class="col-xxl-4">
                                  <label for="fiscalPostalCode"
                                    class="form-label">{{'t-contacts-advanced.t-fiscal-postal-code' |
                                    translate}}</label>
                                  <input type="text"
                                    placeholder="{{'t-contacts-advanced.t-fiscal-postal-code' | translate}}"
                                    class="form-control" id="fiscalPostalCode" formControlName="fiscalPostalCode">
                                </div>
                                <div class="col-xxl-4">
                                  <label for="fiscalCity" class="form-label">{{'t-contacts-advanced.t-fiscal-city' |
                                    translate}}</label>
                                  <input type="text" placeholder="{{'t-contacts-advanced.t-fiscal-city' | translate}}"
                                    class="form-control" id="fiscalCity" formControlName="fiscalCity">
                                </div>
                                <div class="col-xxl-4">
                                  <label for="occupation" class="form-label">{{'t-contacts-advanced.t-occupation' |
                                    translate}}</label>
                                  <input type="text" placeholder="{{'t-contacts-advanced.t-occupation' | translate}}"
                                    class="form-control" id="occupation" formControlName="occupation">
                                </div>
                              </div>

                              <div class="row my-3">
                                <div class="col-xxl-4">
                                  <label for="employer" class="form-label">{{'t-contacts-advanced.t-employer' |
                                    translate}}</label>
                                  <input type="text" placeholder="{{'t-contacts-advanced.t-employer' | translate}}"
                                    class="form-control" id="employer" formControlName="employer">
                                </div>
                                <div class="col-xxl-4">
                                  <label for="actionType" class="form-label">{{'t-contacts-advanced.t-action-type' |
                                    translate}}</label>
                                  <ng-select placeholder="{{'t-contacts-advanced.t-action-type' | translate}}"
                                    formControlName="actionType">
                                    <ng-option *ngFor="let option of proposerActionTypes" [value]="option.value">
                                      {{option.text | translate}}
                                    </ng-option>
                                  </ng-select>
                                </div>
                                <div *ngIf="ownersForm['actionType'].value == 'OTHER'" class="col-xxl-4">
                                  <label for="actionTypeOther"
                                    class="form-label">{{'t-contacts-advanced.t-action-type-other' |
                                    translate}}</label>
                                  <input type="text"
                                    placeholder="{{'t-contacts-advanced.t-action-type-other' | translate}}"
                                    class="form-control" id="actionTypeOther" formControlName="actionTypeOther">
                                </div>
                              </div>

                              <div class="row my-3 align-items-center">
                                <div class="col-xxl-4">
                                  <div class="form-check form-switch form-switch-md form-check-success">
                                    <input class="form-check-input" type="checkbox" role="switch"
                                      id="SwitchPoliticalPositions" formControlName="politicalPositions">
                                    <label class="form-check-label" for="SwitchPoliticalPositions">
                                      {{'t-contacts-advanced.t-political-positions' | translate}}
                                    </label>
                                  </div>
                                </div>
                                <div *ngIf="ownersForm['politicalPositions'].value" class="col-xxl-8">
                                  <label for="politicalDesc" class="form-label">{{'t-contacts-advanced.t-political-desc'
                                    |
                                    translate}}</label>
                                  <input placeholder="{{'t-contacts-advanced.t-political-desc' | translate}}"
                                    class="form-control" id="politicalDesc" formControlName="politicalDesc">
                                </div>
                              </div>
                            </ng-template>
                          </li>
                        </ul>

                        <div [ngbNavOutlet]="advancedNavO"></div>
                      </form>
                    </ng-template>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="row align-items-center">
              <div class="col">
                <div class="tab-content">
                  <ngx-simplebar class="px-3 mx-n3 mb-2" style="height: 45vh;" [options]="{ forceVisible: true }">
                    <div [ngbNavOutlet]="contactsNav"></div>
                  </ngx-simplebar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer bg-body pt-2 pb-2">
    <div class="hstack gap-2 justify-content-end">
      <button type="button" class="btn btn-soft-dark waves-effect waves-light"
        (click)="modal.close('Close click')">{{'t-close' | translate}}</button>

      <button type="button" class="btn btn-primary" id="add-btn" (click)="save()"
        [disabled]="emailInvalid || phoneInvalid || emailExists || phoneExists">
        {{textAddOrUpdateModal | translate }}
      </button>
    </div>
  </div>
</ng-template>
